import api from "../../service/api";
import { Format, SpecialTreatment } from "../../tools/filter";

function balanceFind(data, pairRear) {
  const finddata = data.find((element) => {
    return element.denom.toUpperCase() === pairRear.toUpperCase();
  });
  return (
    finddata || {
      balance: "0",
    }
  );
}

function getGasFee(data) {
  console.log("data.getGasFee", data);
  return Format.setBN({ DECIMAL_PLACES: 18 })
    .init(data.gas)
    .multiply(data.gasPrice)
    .div(Math.pow(10, 6))
    .result(false)
    .toString();
}

export default {
  state: () => ({
    queryBalanceData: {},
    queryHoldBalanceData: {},
    queryBalanceList: [],
  }),
  mutations: {
    SET_QUERY_BALANCE_DATA(state, opt) {
      state.queryBalanceData = opt;
    },
    SET_QUERY_BALANCE_LIST(state, opt) {
      state.queryBalanceList = opt;
    },
    SET_QUERY_HOLD_BALANCE_DATA(state, opt) {
      state.queryHoldBalanceData = opt;
    },
    SET_OPEM_ORDER_AMOUNT(state, opt) {
      state.queryHoldBalanceData.openOrderAllMargin = Format.init(
        state.queryHoldBalanceData.openOrderAllMargin
      )
        .plus(opt.openOrderAllMargin)
        .result(false)
        .toString();
    },
    ADD_POSITION_AMOUNT(state, opt) {
      for (let i = 0; i < opt.length; i++) {
        state.queryHoldBalanceData.positionAmounts.unshift(opt[i]);
      }

      console.log(
        "ADD_POSITION_AMOUNT",
        state.queryHoldBalanceData.positionAmounts
      );
    },
    UPDATE_POSITION_AMOUNT(state, opt) {
      state.queryHoldBalanceData.positionAmounts.forEach((fatherVal, index) => {
        opt.forEach((sonVal) => {
          console.log(
            "sonVal.positionId === fatherVal.positionId",
            sonVal.positionId,
            fatherVal.positionId
          );

          if (sonVal.positionId === fatherVal.positionId) {
            Object.keys(fatherVal).forEach((fvalue) => {
              Object.keys(sonVal).forEach((svalue) => {
                if (fvalue === svalue) {
                  state.queryHoldBalanceData.positionAmounts[index][fvalue] =
                    sonVal[svalue];
                }
              });
            });
          }
        });
      });
      console.log(
        "UPDATE_POSITION_AMOUNT",
        state.queryHoldBalanceData.positionAmounts
      );
    },
    DELETE_POSITION_AMOUNT(state, opt) {
      console.log("DELETE_POSITION_AMOUNT", opt);
      console.log(
        "DELETE_POSITION_AMOUNT-positionAmounts",
        state.queryHoldBalanceData.positionAmounts
      );
      opt.forEach((sonVal) => {
        state.queryHoldBalanceData.positionAmounts.forEach(
          (fatherVal, index) => {
            console.log(
              "sonVal.positionId === fatherVal.positionId",
              sonVal.positionId,
              fatherVal.positionId
            );
            if (sonVal.positionId === fatherVal.positionId) {
              state.queryHoldBalanceData.positionAmounts.splice(index, 1);
            }
          }
        );
      });
      console.log(
        "DELETE_POSITION_AMOUNT",
        state.queryHoldBalanceData.positionAmounts
      );
    },
    UP_BLOCK_HEIGHT(state, val) {
      state.queryHoldBalanceData.blockHeight = val;
    },
  },
  actions: {
    async getQueryBalance({ commit, rootState }, opt) {
      try {
        const queryBalanceData = await api["queryBalance"]({
          address: opt.address,
          pair: opt.pair,
        });
        if (!queryBalanceData) return;
        queryBalanceData.filter(
          (elem) =>
            elem.denom.toUpperCase() === "FX" ||
            elem.denom.toUpperCase() ===
              SpecialTreatment.getPairRearVal(
                rootState.tradingPair.queryPairInfo.pair
              )
        );
        commit("SET_QUERY_BALANCE_LIST", queryBalanceData);
      } catch (error) {
        throw new Error(error);
      }
    },
    setPositionAmount({ commit }, data) {
      // data.forEach((value) => {
      if (data) {
        if (data["addPositionAmounts"]) {
          console.log("addPositionAmounts");
          commit("ADD_POSITION_AMOUNT", data.addPositionAmounts);
        }

        if (data["updatePositionAmounts"]) {
          console.log("updatePositionAmounts");
          commit("UPDATE_POSITION_AMOUNT", data.updatePositionAmounts);
        }
        if (data["deletePositionAmounts"]) {
          console.log("deletePositionAmounts");
          commit("DELETE_POSITION_AMOUNT", data.deletePositionAmounts);
        }
      }
      // });
    },
    setOpenOrderAmount({ commit }, opt) {
      commit("SET_OPEM_ORDER_AMOUNT", opt);
    },
  },
  getters: {
    getQueryBalanceList(state) {
      return state.queryBalanceList;
    },
    getQueryBalanceUSDT(state, rootState) {
      if (!state.queryBalanceList || !rootState.getQueryPairInfo.pair)
        return "0";

      return balanceFind(
        state.queryBalanceList,
        SpecialTreatment.getPairRearVal(rootState.getQueryPairInfo.pair)
      );
    },
    getQueryBalanceSum(state) {
      if (!state.queryBalanceList) return 0;

      let sum = 0;

      state.queryBalanceList.forEach(function (value) {
        sum = Format.init(sum).plus(value.balance).result(false).toString();
      });

      return sum;
    },
    getQueryBalanceFX(state) {
      return balanceFind(state.queryBalanceList, "FX");
    },
    isInsufficientWalletQuotaFX(state, rootState) {
      const finddata = balanceFind(state.queryBalanceList, "FX");

      const gasFeeVal = getGasFee(rootState.gasFeeConfigsFxInfo);
      return Number(gasFeeVal) > Number(finddata.balance || 0) ? false : true;
    },
    isInsufficientWalletQuotaUSDT(state, rootState) {
      const finddata = balanceFind(
        state.queryBalanceList,
        SpecialTreatment.getPairRearVal(rootState.getQueryPairInfo.pair)
      );

      const gasFeeVal = getGasFee(rootState.gasFeeConfigsUsdtInfo);
      return Number(gasFeeVal) > Number(finddata.balance || 0) ? false : true;
    },
    getGasFeeVal(state, rootState) {
      const gasFeeVal = getGasFee(rootState.gasFeeConfigsUsdtInfo);

      return gasFeeVal;
    },
  },
};
